import { CLIENT_ID } from "@api/client-id";
import { runtimeConfig } from "@src/runtime-config";
import { SettingsApiClient } from "@stellar/settings-api-client";

/** Initializes client to SettingsAPI if not already initialized and returns it */
export const settingsApiClient = new SettingsApiClient(runtimeConfig.urls.apiBaseUrl, {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  "X-Holobuilder-Component": CLIENT_ID,
});
